import React, { useCallback, useState } from 'react';

import PipelineAddStepFrame from './PipelineAddStepFrame';
import PipelineConfirmCreationFrame from './PipelineConfirmCreationFrame';
import PipelineStepSelectionFrame from './PipelineStepSelectionFrame';
import usePipelineData from '../PipelineDataContext';

const PIPELINE_CREATION_TAB = {
  SELECT_STEP: 'SELECT_STEP',
  ADD_STEPS: 'ADD_STEPS',
  CONFIRM: 'CONFIRM',
};

const TabRenderer = ({
  cardTitle, 
  selectedTab, 
  setSelectedTab, 
  onClose, 
  startOnAdd = false,
}) => {
  const { pipelineSteps } = usePipelineData();
  const goToSelectStepFrame = useCallback(() => {
    setSelectedTab(PIPELINE_CREATION_TAB.SELECT_STEP);
  }, [setSelectedTab]);

  const goToConfirmationFrame = useCallback(() => {
    setSelectedTab(PIPELINE_CREATION_TAB.CONFIRM);
  }, [setSelectedTab]);

  const goToAddStepsFrame = useCallback(() => {
    setSelectedTab(PIPELINE_CREATION_TAB.ADD_STEPS);
  }, [setSelectedTab]);
  
  if (selectedTab === PIPELINE_CREATION_TAB.CONFIRM) {
    return (
      <PipelineConfirmCreationFrame
        cardTitle={cardTitle}
        handleBack={startOnAdd ? goToAddStepsFrame : goToSelectStepFrame}
        handleGoToAddSteps={goToAddStepsFrame}
        onClose={onClose}
      />
    )
  }

  if (selectedTab === PIPELINE_CREATION_TAB.ADD_STEPS) {
    const originalSteps = startOnAdd ? pipelineSteps : [];
    return (
      <PipelineAddStepFrame cardTitle={cardTitle} originalSteps={originalSteps} handleNext={goToConfirmationFrame} onClose={onClose} />
    )
  }

  return <PipelineStepSelectionFrame cardTitle={cardTitle} handleNext={goToConfirmationFrame} onClose={onClose} />
}

export const PipelineCreationFlow = ({ 
  onClose,
  cardTitle = 'Create New Pipeline',
  startOnAdd = false,
}) => {
  const [selectedTab, setSelectedTab] = useState(startOnAdd ? PIPELINE_CREATION_TAB.ADD_STEPS : PIPELINE_CREATION_TAB.SELECT_STEP);
  
  return (
    <TabRenderer
      cardTitle={cardTitle}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      onClose={onClose}
      startOnAdd={startOnAdd}
    />
  );
};

export default PipelineCreationFlow;
